import { LeaveTeamDevFnReq, LeaveTeamDevFnRes } from '@uploadcam/common';
import { Functions, httpsCallable } from 'firebase/functions';

export class LeaveTeamDevInteractor {
  private readonly leaveTeamDevFn = httpsCallable<LeaveTeamDevFnReq, LeaveTeamDevFnRes>(
    this.functions,
    'leaveTeamDev',
  );

  constructor(private readonly functions: Functions) {}

  public async execute(): Promise<void> {
    await this.leaveTeamDevFn();
  }
}
